class Item {
  _id = '';
  title = {
    el: '',
    en: ''
  };
  description = {
    el: '',
    en: ''
  };
  place = {
    el: '',
    en: ''
  };
  startDate = null
  endDate = null
  startDateFormat = null
  endDateFormat = null
  startYear = null;
  endYear = null;
  period = null;
  category = null;
  mediaFiles = [];

  // TODO: Remove these start
  imageUrls = [];
  imageText = {
    el: '',
    en: ''
  }
  imagesBase64Array = [];
  imagesToRemove = [];
  // TODO: Remove these end
}

module.exports = Item;
